import { CheckCircleFilled } from '@ant-design/icons';
import { AntRow } from 'components/ant/AntRow';
import { Inner, ScreenContainer } from 'components/Mailer/Mailer.styled';
import { Button } from 'components/UI';
import React, { FC, ReactElement } from 'react';

interface Props {
  onCancel: () => void;
  onRetry: () => void;
}

const Failure: FC<Props> = ({ onRetry, onCancel }): ReactElement => (
  <ScreenContainer>
    <Inner failure>
      <AntRow justify="center">
        <CheckCircleFilled />
      </AntRow>

      <AntRow justify="center">
        <h2>Sending Failed!</h2>
      </AntRow>

      <AntRow justify="center">
        <Button onClick={onCancel}>Cancel</Button>

        <Button type="primary" onClick={onRetry} style={{ marginLeft: '10px' }}>
          Try again
        </Button>
      </AntRow>
    </Inner>
  </ScreenContainer>
);

export default Failure;
